var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpecial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 3.33325V13.3333L10 11.6666L6.66671 13.3333V3.33325H13.3334ZM5.00004 16.6666H15C15.4421 16.6666 15.866 16.491 16.1786 16.1784C16.4911 15.8659 16.6667 15.4419 16.6667 14.9999V4.99992C16.6667 4.55789 16.4911 4.13397 16.1786 3.82141C15.866 3.50885 15.4421 3.33325 15 3.33325H5.00004C4.55801 3.33325 4.13409 3.50885 3.82153 3.82141C3.50897 4.13397 3.33337 4.55789 3.33337 4.99992V14.9999C3.33337 15.4419 3.50897 15.8659 3.82153 16.1784C4.13409 16.491 4.55801 16.6666 5.00004 16.6666Z",
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecial);
export default __webpack_public_path__ + "static/media/special.c0e3d5c6e32d395c72c3f954133d9857.svg";
export { ForwardRef as ReactComponent };